// extracted by mini-css-extract-plugin
export default {"aboutpage":"aboutpage_aboutpage__L7mOl"};